module.exports = __webpack_public_path__ + "img/new_bubble_image.6e883ede.png";